import { useParams, useNavigate } from 'react-router-dom';
import instagram from './images/instagram-black.png';

import groups from './GroupData';

export default function GroupDetails() {
  const { groupId } = useParams();
  const group = groups[parseInt(groupId)];
  const navigate = useNavigate();

  if (!group) return <p>Group not found</p>;

  return (
    <div className="group-details">
      <button onClick={() => navigate(-1)}>← Back</button>
      <h2>{group.name}</h2>
      <img src={group.image} alt={group.name} style={{ width: 200 }} />
      <p>{group.description}</p>
      {group.instagram && (
        <div className="group-name">
          <img src={instagram} alt="Logo" className="logo-small" />
          <a href={group.instagram} target="_blank" rel="noreferrer">instagram</a>
        </div>
      )}
    </div>
  );
}
